import React, { useEffect, useRef, useId } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export default function LandmarkDialog({ open, title, children, busy, onClose, footer }) {
  const ref = useRef(null);
  const titleId = useId();
  useEffect(() => {
    const dialog = ref.current;
    if (!open || !dialog) return undefined;
    const previousFocus = document.activeElement;
    dialog.showModal();
    return () => { dialog.close(); if (previousFocus?.isConnected) previousFocus.focus(); };
  }, [open]);
  if (!open) return null;
  return createPortal(<dialog ref={ref} className="lm-modal" aria-labelledby={titleId}
    onCancel={event => { event.preventDefault(); if (!busy) onClose(); }}
    onClick={event => { if (event.target === event.currentTarget && !busy) onClose(); }}>
    <header className="lm-modal-heading"><h2 id={titleId}>{title}</h2>
      <button className="lm-icon-button" type="button" aria-label="창 닫기" disabled={busy} onClick={onClose}><X size={18} /></button>
    </header>
    <div className="lm-modal-body">{children}</div>
    <footer className="lm-modal-footer">{footer}</footer>
  </dialog>, document.body);
}
